import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// StarterCards — personalised conversation openers for Luna's empty state.
//
// Shows up to 4 recent unacknowledged suggestions from past conversations.
// Falls back to LLM-generated profile-aware starters for new users.
// Animated progress bar shown while the LLM generates starters.
import { useEffect, useRef, useState } from "react";
import { api } from "../../lib/apiClient";
function ProgressBar() {
    const [width, setWidth] = useState(0);
    const raf = useRef(0);
    const start = useRef(Date.now());
    useEffect(() => {
        // Animate from 0 → 85% over ~18s (eased), never reaches 100 until done.
        const tick = () => {
            const elapsed = Date.now() - start.current;
            const t = Math.min(elapsed / 18_000, 1);
            const eased = 1 - Math.pow(1 - t, 3); // ease-out-cubic
            setWidth(Math.round(eased * 85));
            if (t < 1)
                raf.current = requestAnimationFrame(tick);
        };
        raf.current = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf.current);
    }, []);
    return (_jsxs("div", { className: "w-full max-w-sm space-y-3", children: [_jsx("p", { className: "text-xs text-slate-500 text-center", children: "Personalising your starters\u2026" }), _jsx("div", { className: "h-0.5 w-full bg-slate-800 rounded-full overflow-hidden", children: _jsx("div", { className: "h-full bg-violet-500 rounded-full transition-none", style: { width: `${width}%` } }) })] }));
}
export function StarterCards({ onSelect }) {
    const [starters, setStarters] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.getStarters()
            .then((r) => setStarters(r.starters))
            .catch(() => { })
            .finally(() => setLoading(false));
    }, []);
    if (loading)
        return _jsx(ProgressBar, {});
    return (_jsx("div", { className: "flex flex-col gap-2 w-full max-w-sm", children: starters.map((item) => (_jsx("button", { onClick: () => {
                if (!item.id.startsWith("b") && !item.id.startsWith("g")) {
                    api.acknowledgeInsight(item.id).catch(() => { });
                }
                onSelect(item.cta_text);
            }, className: "text-left text-[13px] text-slate-400 bg-slate-900 hover:bg-slate-800/60 border border-slate-800/60 rounded-lg px-4 py-3 transition-colors", children: item.cta_text }, item.id))) }));
}
